import React from 'react';

const Spinner = () => (
  <img src="/images/ring.svg" alt="Loading" />
);

export default Spinner;



// WEBPACK FOOTER //
// ./web/components/Spinner.js